// Main component
(() => {
  const section = document.querySelector('[data-section-type="product"] [data-form-wrapper]');

  if (!section) {
    return;
  }

  const form = section.querySelector('form.product-form');

  if (!form) {
    return;
  }

  const originalInput = section.querySelector('[data-original-input-id]');

  if (!originalInput) {
    return;
  }

  const checkboxes = section.querySelectorAll('.product__warranty-addon__product-label input[type="checkbox"]');

  if (!checkboxes.length) {
    return;
  }

  function checkedCheckboxes() {
    return [...checkboxes].filter(checkbox => checkbox.checked === true);
  }

  function removeHiddenInputs() {
    form.querySelectorAll('input[data-warranty-addon="true"]').forEach(input => input.remove());
  }

  // This function syncs the hidden inputs based on the state of the checkboxes
  function syncHiddenInputs() {
    removeHiddenInputs();

    // Find all checkboxes that are currently checked
    const _checkedCheckboxes = checkedCheckboxes();

    if (_checkedCheckboxes.length > 0) {
      _checkedCheckboxes.forEach(checkbox => {
        const hiddenIdInput = document.createElement('input');

        hiddenIdInput.type = 'hidden';
        hiddenIdInput.name = 'id[]';
        hiddenIdInput.value = checkbox.closest('label').dataset.variantId;
        hiddenIdInput.dataset.warrantyAddon = 'true';

        const hiddenPropertyInput = document.createElement('input');

        hiddenPropertyInput.type = 'hidden';
        hiddenPropertyInput.name = 'properties[_warranty]';
        hiddenPropertyInput.value = originalInput.value;
        hiddenPropertyInput.dataset.warrantyAddon = 'true';

        form.appendChild(hiddenIdInput);
        form.appendChild(hiddenPropertyInput);

        originalInput.name = 'id[]';
      });
    } else {
      form.querySelectorAll('input[data-warranty-addon="true"]').forEach(checkbox => checkbox.remove());
      // If NO checkboxes are checked, create the original single hidden input
      originalInput.name = 'id';
    }
  }

  // Function to handle the click event on a checkbox
  function handleCheckboxClick(event) {
    const clickedCheckbox = event.target;

    // If the clicked checkbox is now checked, uncheck all others.
    if (clickedCheckbox.checked) {
      checkboxes.forEach(checkbox => {
        if (checkbox !== clickedCheckbox) {
          checkbox.checked = false;
        }
      });
    }

    // After handling the click, always update the hidden inputs
    syncHiddenInputs();
  }

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('click', handleCheckboxClick, { passive: true });
  });
})();

// Popup
(() => {
  const section = document.querySelector('[data-section-type="product"] [data-form-wrapper]');

  if (!section) {
    return;
  }

  const checkboxes = section.querySelectorAll('.product__warranty-addon__product-label input[type="checkbox"]');

  if (!checkboxes.length) {
    return;
  }

  const addToCartButton = section.querySelector('form.product-form button[data-add-to-cart]');
  const openPopupButton = section.querySelector('#warranty-interstitial-popup-trigger');
  const popupContainer = section.querySelector('#warranty-interstitial-popup');

  if (!addToCartButton || !openPopupButton || !popupContainer) {
    return;
  }

  const closePopupButton = popupContainer.querySelector('.warranty-interstitial-popup__close');
  const rejectButton = popupContainer.querySelector('.warranty-interstitial-popup__reject');
  const plansButtons = popupContainer.querySelectorAll('.warranty-interstitial-popup__body-buttons button');
  const addPlanButton = popupContainer.querySelector('.warranty-interstitial-popup__button button');

  let isInterstitial = false;

  function checkedCheckboxes() {
    return [...checkboxes].filter(checkbox => checkbox.checked === true);
  }

  function hasPlanSelected() {
    return checkedCheckboxes().length > 0;
  }

  function showPopup() {
    popupContainer.style.display = 'block';
  }

  function hidePopup() {
    popupContainer.style.display = 'none';
    isInterstitial = false;
  }

  function handlePlanButtonClick(evt) {
    plansButtons.forEach((button) => {
      button.dataset.selected = 'false';
    });

    const button = evt.target.closest('button') || evt.target;

    button.dataset.selected = 'true';
  }

  function rejectWarranties() {
    checkedCheckboxes().forEach(checkbox => checkbox.click());

    if (isInterstitial) {
      addToCartButton.click();
    }

    hidePopup();
  }

  function addWarranty() {
    const selectedPlanButton = [...plansButtons].filter(button => button.dataset.selected === 'true')[0] || null;

    if (!selectedPlanButton || !selectedPlanButton.dataset.selected) {
      return;
    }

    section.querySelector(`.product__warranty-addon__product-label[data-variant-id="${selectedPlanButton.dataset.variantId}"] input[type="checkbox"]:not(:checked)`)?.click();
    addToCartButton.click();
    hidePopup();
  }

  function showInterstitial(evt) {
    if (!hasPlanSelected() && !isInterstitial) {
      evt.preventDefault();
      evt.stopPropagation();

      isInterstitial = true;
      showPopup();
    }
  }

  openPopupButton?.addEventListener('click', showPopup, { passive: true });
  closePopupButton.addEventListener('click', hidePopup, { passive: true });
  // When the user clicks anywhere outside of the popup content, close it
  window.addEventListener('click', function (event) {
    // Check if the click was on the dark background
    if (event.target == popupContainer) {
      hidePopup();
    }
  }, { passive: true });

  plansButtons.forEach(button => button.addEventListener('click', handlePlanButtonClick, { passive: true }));
  rejectButton?.addEventListener('click', rejectWarranties, { passive: true });
  addPlanButton?.addEventListener('click', addWarranty, { passive: true });
  addToCartButton.addEventListener('click', showInterstitial);
})();